import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=2c0b1abe&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=2c0b1abe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0b1abe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c0b1abe')) {
      api.createRecord('2c0b1abe', component.options)
    } else {
      api.reload('2c0b1abe', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=2c0b1abe&scoped=true&", function () {
      api.rerender('2c0b1abe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4h3u5z1Z3gd7G/JS/teamMember.vue"
export default component.exports